const URL = "/api"

module.exports = {
	AUTH_LINK: process.env.VUE_APP_AUTHURL,
	ADMIN_LINK: process.env.VUE_APP_ADMIN_LINK,
	SCORE_LINK: process.env.VUE_APP_SCORE_LINK,
	EIGHTD_LINK: process.env.VUE_APP_EIGHTD_LINK,
	CAR_LINK: process.env.VUE_APP_CAR_LINK,
	DFX_LINK: process.env.VUE_APP_DFX_LINK,
	HELP_LINK: process.env.VUE_APP_HELP_LINK,
	LOGINURL: process.env.VUE_APP_LOGINURL,       // 登录跳转链接
	ADMINURL: process.env.VUE_APP_ADMINURL,       // 后台 
	EIGHTDURL: process.env.VUE_APP_EIGHTDURL,     // 8d
	SCOREURL: process.env.VUE_APP_SCOREURL,
	HET_BASE: process.env.VUE_APP_HET_BASE,
	VERSION: process.env.VUE_APP_VERSION,
	COMPILETIME: process.env.VUE_APP_COMPILETIME
}  